import type {
  MixedSelectDropdownItem
} from 'types';

export function mapCountriesToMixedSelectDropdownItem(
  regions: Array<string>,
  countries: Array<string>
): Array<MixedSelectDropdownItem> {
  return regions.map(r => ({
    label: r.toUpperCase(),
    value: r,
    identifier: r,
    isDisabled: false,
    isFocused: false,
    isSelected: countries.includes(r)
  }));
}

export function mapMixedSelectDropdownItemsToCountries(
  items: Array<MixedSelectDropdownItem
>): Array<string> {
  return items.filter(i => i.isSelected).map(i => i.value);
}
